goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Close$default");
shadow.js.shim.module$$carbon$icons_react$es$Close$default = shadow.js.require(357, {}).default;
